import openNotification from './openNotification';

export const handleArrayBufferErrors = (error: any): any => {
  let errorDetail = 'Произошла ошибка';
  let errorMessage = '';

  if (error?.response?.data && error.response.data instanceof ArrayBuffer) {
    try {
      const decoder = new TextDecoder('utf-8');
      const decodedString = decoder.decode(error.response.data);
      const errorData = JSON.parse(decodedString);
      errorDetail = errorData?.detail;
      errorMessage = errorData?.message;
    } catch (decodeError) {
      console.error('Ошибка при декодировании ответа:', decodeError);
    }
  } else {
    errorMessage = error?.response?.data?.detail || error?.response?.data?.message || errorMessage;
  }

  openNotification('error', {
    code: '',
    message: errorMessage,
    detail: errorDetail,
  });
};
